module.exports = __webpack_public_path__ + "images/4674e3a6.bg1.png";


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/bg1.png
// module id = 367
// module chunks = 0